import React, {useEffect, useState} from 'react';
import axios from "axios";
import {ApiName, ApiNameGrant} from "../APIname";
import {Button, Input, message, Modal, Select, Table, Popconfirm} from "antd";
import {ReloadOutlined} from '@ant-design/icons';
import ModalForma from "../componenta/modalForma";
import ModalGrantManaviy from "../componenta/modalGrantManaviy";
import {use} from "i18next";
import {useNavigate} from "react-router-dom";
import {exportToExcel} from '../componenta/exportToExcel';
import {fetchAllPagesAndExportToExcel} from '../componenta/fetchAllPagesAndExportToExcel';

function GrantStudent(props) {
    const [fulInfo] = useState(JSON.parse(localStorage.getItem("myCat")));
    const [data, setData] = useState([])
    const [Fakulty, setFakulty] = useState([]);
    const [loadingGpaIds, setLoadingGpaIds] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [user, setUser] = useState()
    const navigate = useNavigate();
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 20,
            total: 100
        },
    });

    const [SRC, setSRC] = useState({})


    useEffect(() => {
        grantList(1, tableParams.pagination.pageSize)
        DepartmenGet(11)
    }, [SRC])

    function DepartmenGet(id) {
        axios.get(`${ApiName}/api/department?structureCode=${id}`, {}).then((response) => {
            setFakulty(response.data);
        }).catch((error) => {
            console.log(error)
        });
    }

    function handleUpdateGpa(profileIdNumber) {
        if (loadingGpaIds.includes(profileIdNumber)) return; // 👈 YANGI QO‘SHILDI

        setLoadingGpaIds(prev => [...prev, profileIdNumber]);
        axios.put(`${ApiName}/api/gpa/update`, {
            profileIdNumber: profileIdNumber
        }, {
            headers: {"Authorization": `Bearer ${fulInfo?.accessToken}`}
        }).then((response) => {
            message.success("GPA yangilandi!");
            grantList(tableParams.pagination.current, tableParams.pagination.pageSize);
        }).catch((error) => {
            console.log(error);
            message.error("GPA yangilashda xatolik yuz berdi!");
        }).finally(() => {
            setLoadingGpaIds(prev => prev.filter(id => id !== profileIdNumber));
        });
    }


    function grantList(page, pageSize) {
        // console.log("Access token:", fulInfo?.accessToken);
        axios.get(`${ApiName}/grant/api/applications-filter`, {
            headers: {"Authorization": `Bearer ${fulInfo?.accessToken}`},
            params: {
                src: SRC?.src,
                educationTypeName: SRC.educationTypeName,
                departmentName: SRC.departmentId,
                groupLangName: SRC.groupLangName,
                applicationStatus: SRC.applicationStatus,
                size: pageSize,
                page: page - 1
            }
        })
            .then((response) => {
                console.log(response)
                setData(response?.data?.data?.content || []);
                setTableParams(prev => ({
                    ...prev,
                    pagination: {
                        ...prev.pagination,
                        current: page, // 👈 currentni ham saqlaylik
                        pageSize: response.data.data.size,
                        total: response.data.data.totalElements,
                    },
                }));

            }).catch((error) => {
            console.log(error)
        });
    }

    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const baseColumns = [
        // umumiy ustunlar
        {
            title: '№',
            dataIndex: 'index',
            key: 'index',
            render: (text, record, index) => (
                (tableParams.pagination.current - 1) * tableParams.pagination.pageSize + index + 1
            ),
            width: 70,
        },
        {
            title: "Rasm",
            render: img => <img width={100} src={img.student?.imageUrl} alt={img.student?.imageUrl}/>,
        },
        {
            title: "Student ID",
            render: edu => <span>{edu?.student?.profile_id_number}</span>,
        },
        {
            title: "F.I.SH",
            render: edu => <span>{edu?.student?.fullName}</span>,
        },
        {
            title: "Kurs",
            render: edu => <span>{edu?.student?.levelInfo?.name}</span>,
        },
        {
            title: "Guruh",
            render: edu => <span>{edu?.student?.groupInfo?.name}</span>,
        },
        {
            title: "O'quv yili",
            render: edu => <span>{edu?.education_year_info?.name}</span>,
        },
        {
            title: 'Fakultet',
            render: edu => <span>{edu?.student?.departmentInfo?.name}</span>,
        },
        {
            title: "Yo'nalish",
            render: edu => <span>{edu?.student?.specialtyInfo?.name}</span>,
        },
        {
            title: "Hozirgi holati",
            render: edu => <span>{edu?.student?.paymentFormInfo?.name}</span>,
        },
        {
            title: 'Telefon',
            dataIndex: 'phone'
        },
        {
            title: 'Ijtimoiy faollik ball',
            render: edu => <span>{edu?.departmentRating === null ? "yo‘q" : edu?.departmentRating}</span>,
        },
    ];

    const conditionalColumns = [];

    if (fulInfo?.currentRole !== "ROLE_DEPARTMENT") {
        conditionalColumns.push(
            {
                title: 'GPA',
                render: edu => <span>{edu?.student?.avg_gpa === null ? "yo‘q" : edu?.student?.avg_gpa}</span>
            },
            {
                title: 'Akademik o\'zlashtirish ko\'rsatkichi',
                render: edu => <span>{edu?.academicRating === null ? "yo‘q" : edu?.academicRating}</span>
            },
            {
                title: 'Umumiy ball',
                render: edu =>
                    <span>{edu?.academicAndDepartmentRating === null ? "yo‘q" : edu?.academicAndDepartmentRating}</span>
            },
            {
                title: "GPA ni yangilash",
                render: edu => (
                    <Popconfirm
                        title="Ishonchingiz komilmi?"
                        description="Ushbu talabaning GPA balli yangilanadi. Davom etishni xohlaysizmi?"
                        okText="Ha, yangilansin"
                        cancelText="Yo‘q"
                        onConfirm={() => {
                            if (edu?.student?.profile_id_number) {
                                handleUpdateGpa(edu.student.profile_id_number);
                            } else {
                                message.warning("Student ID mavjud emas");
                            }
                        }}
                    >
                        <Button
                            type="primary"
                            icon={<ReloadOutlined />}
                            loading={loadingGpaIds.includes(edu?.student?.profile_id_number)}
                        >
                            Yangilash
                        </Button>
                    </Popconfirm>

                    // <Popconfirm
                    //     title="Ishonchingiz komilmi?"
                    //     description="Ushbu talabaning GPA balli yangilanadi. Davom etishni xohlaysizmi?"
                    //     okText="Ha, yangilansin"
                    //     cancelText="Yo‘q"
                    //     onConfirm={() => {
                    //         if (edu?.student?.profile_id_number) {
                    //             handleUpdateGpa(edu.student.profile_id_number);
                    //         } else {
                    //             message.warning("Student ID mavjud emas");
                    //         }
                    //     }}
                    // >
                    //     <Button
                    //         type="primary"
                    //         icon={<ReloadOutlined/>}
                    //         loading={loadingGpaIds.includes(edu?.student?.profile_id_number)}
                    //     />
                    //
                    // </Popconfirm>

                )
            }
        );
    }

    const otherColumns = [
        {
            title: 'Asoslovchi hujjat',
            render: edu =>
                edu?.files[0]?.file?.url ? (
                    <button className="btn btn-success">
                        <a style={{color: "#fff"}} href={edu.files[0].file.url} target="_blank"
                           rel="noopener noreferrer">
                            Hujjatni ko‘rish
                        </a>
                    </button>
                ) : (
                    <button className="btn btn-danger" onClick={() => message.error("Fayl joylanmagan")}>
                        Hujjat mavjud emas
                    </button>
                )

        },
        {
            title: '',
            render: user =>
                fulInfo.currentRole !== "ROLE_ADMIN" &&
                <button className="btn btn-success" onClick={() => {
                    setUser(user);
                    setIsModalOpen(true);
                }}>
                    Ball berish
                </button>
        }
    ];

    const columns = [...baseColumns, ...conditionalColumns, ...otherColumns];
    return (
        <div>
            <div className="d-flex  align-items-center mb-4 gap-2">
                <Select style={{width: 400}}
                        allowClear showSearch name="fakultet"
                        onChange={(e) => {
                            setSRC({...SRC, departmentId: e})
                        }}
                        placeholder="Fakultet"
                        optionFilterProp="children"
                        filterOption={(input, option) => (option?.label?.toLowerCase() ?? '').startsWith(input.toLowerCase())}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())}
                        options={
                            Fakulty && Fakulty.map((item, index) => (
                                {
                                    value: item.name,
                                    label: item.name
                                }))}
                />
                <Select style={{width: 400}}
                        allowClear showSearch name="Til"
                        onChange={(e) => {
                            setSRC({...SRC, groupLangName: e})
                        }}
                        placeholder="Ta'lim tili"
                        optionFilterProp="children"
                        filterOption={(input, option) => (option?.label?.toLowerCase() ?? '').startsWith(input.toLowerCase())}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())}
                        options={[
                            {
                                value: "O‘zbek",
                                label: "O‘zbek"
                            },
                            {
                                value: "Rus",
                                label: "Rus"
                            }
                        ]}
                />
                <Input style={{width: 400}} type="text" placeholder="FISH  /  Telefon raqami"
                       onChange={(e) => {
                           setSRC({...SRC, src: e.target.value})
                       }}
                />
                <Select style={{width: 400}}
                        allowClear showSearch name="ball"
                        onChange={(e) => {
                            setSRC({...SRC, applicationStatus: e})
                        }}
                        placeholder="Ball berilganlar"
                        optionFilterProp="children"
                        filterOption={(input, option) => (option?.label?.toLowerCase() ?? '').startsWith(input.toLowerCase())}
                        filterSort={(optionA, optionB) =>
                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())}
                        options={[
                            {
                                value: "PENDING",
                                label: "Ball berilmaganlar"
                            },
                            {
                                value: "SCORED",
                                label: "Ball berilganlar"
                            }
                        ]}
                />
                <Select
                    style={{width: 400}}
                    allowClear
                    showSearch
                    placeholder="Ta`lim darajasi"
                    onChange={(value) => {
                        setSRC({...SRC, educationTypeName: value});
                    }}
                    options={[
                        {
                            value: "Bakalavr",
                            label: "Bakalavr"
                        },
                        {
                            value: "Magistr",
                            label: "Magistr"
                        }
                    ]}
                />

                <Button type="primary" onClick={() => exportToExcel(data)}>Excelga yuklash</Button>

                <Button
                    type="primary"
                    onClick={() =>
                        fetchAllPagesAndExportToExcel({
                            apiUrl: `${ApiName}/grant/api/applications-filter`,
                            filters: {
                                phone: SRC?.phone,
                                educationTypeName: SRC.educationTypeName,
                                departmentName: SRC.departmentId,
                                groupLangName: SRC.groupLangName,
                                applicationStatus: SRC.applicationStatus
                            },
                            token: fulInfo?.accessToken,
                            fileName: 'barcha_talabalar.xlsx'
                        })
                    }
                >
                    📥 Barchasini Excelga yuklash
                </Button>
            </div>

            <Modal
                title="Grant oluvchi talabaga ball berish"
                width={600}
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
            >
                <ModalGrantManaviy
                    handleCancel={handleCancel}
                    user={user}
                    onSuccess={() => grantList(tableParams.pagination.current, tableParams.pagination.pageSize)}
                />
            </Modal>

            <Table columns={columns}
                   pagination={{
                       total: tableParams.pagination.total,
                       pageSize: tableParams.pagination.pageSize,
                       onChange: (page, pageSize) => {
                           grantList(page, pageSize);
                       }
                   }}
                   dataSource={data?.map(item => {
                       return {...item, key: item.id}
                   })}/>
        </div>
    );
}

export default GrantStudent;